<template>
  <a class="outlines-button" :href="link" :title="text" target="target">
    <div class="outlines-button__frame"><!--
    --><span class="outlines-button__text">{{ text }}</span>
    </div>
  </a>
</template>

<script>
export default {
  name: 'OutlinesButton',
  props: {
    text: { type: String, default: '' },
    link: { type: String, default: '' },
    target: { type: String, default: '_blank' }
  }
}
</script>

<style lang="scss">
.outlines-button {
  $comp: &;
  display: inline-block;
  position: relative;
  min-width: 143px;
  height: 41px;
  transition: color 0.3s ease-in-out;
  cursor: pointer;

  &:before {
    content: "";
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    background: #e8a687;
  }

  &__frame {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 28px;
    color: #dd6f6f;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: #efefef;
    border: 2px solid #dd6f6f;
    transform: translate(6px, -6px);
    transition:
      transform 0.3s,
      background-color 0.3s;
  }

  &__text {
    display: inline-block;
    width: 100%;
    height: 100%;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.875em;
    text-decoration: none;
    @include use-vertical-align();
  }

  &:active {
    #{$comp}__frame {
      transform: translate(3px, -3px);
    }
  }
}

.desktop {
  .outlines-button {
    $comp: ".outlines-button";
    &:hover {
      #{$comp}__frame {
        background: #ffffff;
      }
    }
  }
}
</style>
